import config from '../../server.config';
const urlBase = `${config.server_url}/api/form/open`;

export const getServerApiMenu = (query, id) => {
  return fetch(`${urlBase}/menus?searchCriteria=${query}`, {
    headers: {
      'company-id': id,
    },
  }).then(res => res.json());
};

export const getServerApiDietDetails = id => {
  return fetch(`${urlBase}/order-form/diet-details`, {
    headers: {
      'company-id': id,
    },
  }).then(res => res.json());
};

export const getServerApiCompanyParams = id => {
  return fetch(`${urlBase}/company-details/${id}/params`, {
    headers: {
      'company-id': id,
    },
  }).then(res => res.json());
};
